<template>
    <div class="transactions-history__modal">
        <div class="notice">
            {{ $t(description) | capitalize }}
        </div>
        <div class="transactions-history__body">
            <div v-if="!isLoading && histories.length === 0">
                {{ $t('no transactions') | capitalize }}
            </div>
            <HistoryGrid
                :histories="histories"
                :currencyDisplay="currencyDisplay"
                @cancelWithdrawal="onCancelWithdrawal"
                @ticketIdClick="openTicketModal"
            />
            <div
                v-if="isLoading"
                class="spinner-container"
            >
                <SpinnerBars/>
            </div>
            <button
                v-if="hasMore"
                @click="onLoadMoreClick"
                class="btn btn__secondary transactions-history__load-more"
            >
                {{ $t('see older') | upperCase }}
            </button>
        </div>
    </div>
</template>

<script>
    import i18n from '@app/localization/i18n';
    import { mapActions, mapGetters } from 'vuex';
    import { HistoryType } from '@store/modules/ui/user/history/enums';
    import { errorGuard } from '@app/utils';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import HistoryGrid from './components/HistoryGrid';

    const descriptions = {
        [HistoryType.bets]: 'you can see your sports betting and lotto transactions.',
        [HistoryType.transactions]: 'here you can track the history of all deposit and withdrawal transactions',
        [HistoryType.casinoPlays]: 'here you can track the history of all casino transactions.',
    };

    export default {
        name: 'HistoryTypeContainer',
        props: {
            type: {
                type: String,
                required: true,
            },
            currencyDisplay: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                page: 1,
                error: '',
            };
        },
        created() {
            this.reset();
            this.fetch();
        },
        computed: {
            ...mapGetters('ui/user/history', [
                'histories',
                'nextHistories',
                'isLoading',
            ]),
            description() {
                return descriptions[this.type];
            },
            hasMore() {
                return !!this.nextHistories.length;
            }
        },
        methods: {
            ...mapActions('ui/user/history', [
                'fetchHistory',
                'cancelWithdrawal',
                'setIsLoading',
                'reset',
            ]),
            ...mapActions('ui/modal', [
                'pushModal',
            ]),
            ...mapActions('data/tickets', [
                'fetchTicket',
            ]),
            async onCancelWithdrawal(history) {
                this.error = '';
                await errorGuard({
                    action: () => this.cancelWithdrawal(history),
                    onError: () => {
                        this.error = 'Something went wrong. Please try again';
                    },
                });
            },
            onLoadMoreClick() {
                this.page = this.page + 1;
                this.fetch();
            },
            async fetch() {
                this.setIsLoading(true);
                await errorGuard({
                    action: () => this.fetchHistory({
                        type: this.type,
                        page: this.page,
                    })
                });
                this.setIsLoading(false);
            },
            async openTicketModal(id) {
                await errorGuard({
                    action: async () => {
                        const ticket = await this.fetchTicket(id);
                        if (ticket) {
                            this.pushModal({
                                code: Modals.singleTicket.code,
                                goBack: true,
                                data: {
                                    ticket
                                }
                            });
                        } else {
                            this.pushModal({
                                code: Modals.message.code,
                                goBack: true,
                                data: {
                                    title: `${i18n.t('ticket')}: ${id}`,
                                    // eslint-disable-next-line max-len
                                    content: i18n.t('It has been more than 3 months since you played this ticket, it\'s details are no longer available, but you can still see the status and the gain.'),
                                },
                            });
                        }
                    },
                });
            }
        },
        components: {
            HistoryGrid,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/history/HistoryTypeContainer.vue